<template>
  <Layout>
    <ServerStatusListPage
      title="Submitted Applications"
      subtitle="Applications submitted by applicants and waiting for a reviewer."
      card-title="Submitted"
      icon="send"
      tone="green"
      by-label="Assigned To"
      search-placeholder="Search submitted application..."
      empty-message="No submitted applications"
      endpoint="/applications/all_application_details/"
      status="submitted"
      server-status-filter
    />
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import ServerStatusListPage from "@/components/shared/ServerStatusListPage.vue";

// Admin: applications whose status is "submitted". Paged, searched and sorted on the server;
// page / search / sort stay in the URL.
export default {
  components: {
    Layout,
    ServerStatusListPage,
  },
};
</script>